import { render, staticRenderFns } from "./AdminTierForm.vue?vue&type=template&id=2aa267fd&"
import script from "./AdminTierForm.vue?vue&type=script&lang=js&"
export * from "./AdminTierForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports